import * as SCREEN from "./events/screen";
import * as CONTENT from "./events/content";
import * as AUTHENTICATION from "./events/authentication";
import * as NEWSLETTER from "./events/newsletter";
import * as CLICKED from "./events/clicked";
import * as AD from "./events/ad";

const EVENTS_VALIDATION_SCHEMAS = {
  "Activity Viewed": SCREEN.activityViewed,
  "Activity Downloaded": CONTENT.activityDownloaded,
  "Video Played": CONTENT.videoPlayed,
  "Content Shared": CONTENT.shared,
  "User Identification Modal Viewed":
    AUTHENTICATION.userIdentificationModalViewed,
  "User Identified": AUTHENTICATION.userIdentified,
  "Newsletter Sign Up": NEWSLETTER.newsletterSignUp,
  "Blog Post Viewed": SCREEN.blogPostViewed,
  "Link Clicked": CLICKED.link,
  "Liability Disclaimer Viewed": AD.liabilityDisclaimerViewed,
  "Leaving GoNoodle Bumper Displayed": SCREEN.leavingGoNoodleBumperViewed,
};

function validate(event, properties) {
  const schema = EVENTS_VALIDATION_SCHEMAS[event];
  const { error } = schema.validate(properties);
  return {
    properties,
    event,
    error,
  };
}

export { validate };
